export const petBeneficiaryProfile = {
  relationship: '',
  name: {
    firstName: '',
    lastName: ''
  },
  dateOfBirth: {
    year: '',
    month: '',
    day: '',
  },
  identityNo: '',
  phoneNo: '',
  mail: '',
  address: {
    city: '',
    area: '',
    road: ''
  },
}

export const petNoticeData = {
  /*petHasOtherInsu: {
    value: false,
    desc: ''
  },*/
  //isCheckCoverage: false,
 // famiyYearIncome: '',
  //economicSources: '',
  isNative: true,
  //job: '',
  /*isOverSixMons: {
    value: false,
    desc: ''
  },
  isPolitician: {
    value: false,
    desc: ''
  },
  PremiumSources:
  {
    value: '',
    desc: ''
  },
  IsPolicyLoan:false  */
}

export const petHealthNoticeData={
  isPetMedical:false,
  isOtherPetInsu: false,
  isPetTreatment: false,
  hasPetDisability: false,           
  petMedicalReport:false
}